import './App.css';
import './style.css';
import'./historyStyle.css';
import React, { useEffect } from 'react';
import initializePackery from './dragdrop';
import {  handleButtonClick, handleCloseClick, handleMemoClick, handleDicisionClick, submitForm,handleDeleteButton,closeNameDicision,editNameDicision } from './uiEventHandler';
//import Sprintboard from "./hooks/sprintboard";
import { Sprintboard,setWebsocketProvider } from './hooks/sprintboard';
import { historyHandler } from './sprintHistory';

function Top() {




  return (
    <div >


	    <div id="modal-overlay" className="modal-overlay closed" ></div>
	    <div id="modal" className="modal " data-grid="" data-key="">
			
		      <textarea id="taskTitle" className="taskTitle" defaultValue={""}></textarea>
		      <p id="creator" className="creator"/*作成者 */>作成者</p>
		      <textarea  id="creatorTextArea" className="creatorTextArea" defaultValue={""}></textarea>
		      <p id="difficulty" className="difficulty" /*大変さ */>大変さ</p>
		      <textarea id="difficultyTextArea" className="difficultyTextArea" defaultValue={""}></textarea>
			  {/*
		      <p id="time" className="time" >かかった時間</p>
		      <p id="timeText" className="timeText" >0時間</p>
			  */}
		      <p id="content" className="content" /* 内容*/>内容</p>
		      <textarea id="contentTextArea" className="contentTextArea" defaultValue={""}></textarea>
		      <button id="dicisionButton" className="dicisionButton" onClick={handleDicisionClick}/*決定 */>決定</button>
		      <button id="closedButton" className="closedButton" onClick={handleCloseClick}/*閉じる */>閉じる</button>
			  <button id="deleteButton" className="deleteButton" onClick={handleDeleteButton}/*削除 */>削除</button>
		      <p id="memoButton" className="memoButton" /*メモ */>メモ</p>
		      <textarea id="memoTextArea" className="memoTextArea" defaultValue={""}></textarea>
			  
			  <div id="taskManage" className="taskManage">
				<label htmlFor="taskColor">color</label>
				<input type="color" id="taskColor" />
			  </div>
			  

			  
		
	    </div>

		<div id="history-modal-overlay" className="history-modal-overlay" ></div>
	    <div id="historyModal" className="historyModal "></div>

		<div id="editNameModal" className="editNameModal">
			<p className="member member0Text">0人目</p>
			<p className="member member1Text">1人目</p>
			<p className="member member2Text">2人目</p>
			<p className="member member3Text">3人目</p>
			<p className="member member4Text">4人目</p>

			<textarea id="name0" className="name name0"></textarea>
			<textarea id="name1" className="name name1"></textarea>
			<textarea id="name2" className="name name2"></textarea>
			<textarea id="name3" className="name name3"></textarea>
			<textarea id="name4" className="name name4"></textarea>

			<button id="editNameDicision" className="editNameDicision" onClick={editNameDicision}>決定</button>
			<button id="editClosed" className="editClosed" onClick={closeNameDicision}>閉じる</button>

		</div>
		
	
	{/*
	      <div className="allgrid">
	
		
		    <div className="item" onClick={handleButtonClick}>プロダクトバックログ
			    <button id="makeTask" >+</button>
			
		    </div>
		    <div className="item" >スプリントバックログ</div>
		    <div className="item" >調査中</div>
		    <div className="item" >Doing</div>
		    <div className="item" >Done</div>
{/*}
		        <div className="grid pBacklog">

			        <div className="grid-item" >...</div>
			        <div className="grid-item" >...</div>
			        <div className="grid-item" >...</div>
			        <div className="grid-item" >...</div>
			        <div className="grid-item" >...</div>
			        <div className="grid-item" >...</div>
			        <div className="grid-item" >...</div>
			        <div className="grid-item" >...</div>
			        <div className="grid-item test" >...</div>
		        </div>
  

		        <div className="grid sBacklog">
			        <div className="grid-item" >...</div>
			        <div className="grid-item" >...</div>
		        </div>

		        <div className="grid investigation"></div>
		        <div className="grid doing"></div>
		        <div className="grid done"></div>
 
  
	    </div>
*/}
{console.log("sprintboard mae App")}
{setWebsocketProvider()}
<Sprintboard/>


        <script src="js/dragdrop.js"></script>
	    <script src="js/makeTask.js"></script>
	    <script type="module" src="js/communication.js"></script>
		

        
	        
    </div>
  );
}

export default Top;